var InformationBarAlertType;
(function (InformationBarAlertType) {
    InformationBarAlertType["BADGE"] = "badge";
    InformationBarAlertType["ICON"] = "icon";
})(InformationBarAlertType || (InformationBarAlertType = {}));
export { InformationBarAlertType, };
//# sourceMappingURL=information-bar-constants.js.map